import React, { useState, useRef } from 'react'
import { notification } from 'antd'
import SewingThreadColorPage from './SewingThreadColorPage'
import { getItemSewingThreadColor, updateItemSewingThreadColor } from '../../../services/api/3dApi'
import '../styles/index.scss'

const DEFAULT_COLOR_PRIORITY = ['GREY', 'BLACK', 'WHITE', 'RED']

const _getDefaultUnresolvedColor = (allowedColors) => {
    if (!Array.isArray(allowedColors)) return DEFAULT_COLOR_PRIORITY[0]
    return DEFAULT_COLOR_PRIORITY.find(color => allowedColors.includes(color)) || DEFAULT_COLOR_PRIORITY[0]
}

const SewingThreadColorContainer = () => {
    const inputRef = useRef(null)
    const [inputValue, setInputValue] = useState('')
    const [loading, setLoading] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState('')
    const [data, setData] = useState(null)
    const [selectedColor, setSelectedColor] = useState(undefined)
    const [showReasonBlock, setShowReasonBlock] = useState(false)

    const _reset = () => {
        setShowReasonBlock(false)
        setInputValue('')
        setData(null)
        setSelectedColor(undefined)
        setError('')
        if (inputRef.current) inputRef.current.focus()
    }

    const _fetchThreadColor = async (barcode) => {
        setLoading(true)
        setError('')
        try {
            const { data: res } = await getItemSewingThreadColor(barcode)
            const { success, data: payload, message: mess, error: errMsg } = res || {}
            if (!success || !payload) {
                setData(null)
                setError(errMsg || mess || 'Không tìm thấy item')
                return
            }
            const isUnresolved = payload.thread.current === null
            setData(payload)
            setSelectedColor(isUnresolved ? _getDefaultUnresolvedColor(payload.thread.allowed_colors) : payload.thread.current)
            setShowReasonBlock(isUnresolved)
        } catch (e) {
            setData(null)
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    const _onSubmit = (e) => {
        e.preventDefault()
        const barcode = inputValue.trim()
        if (!barcode) return

        if (!/^#\d+_\d+$/.test(barcode)) {
            setError('Item không đúng định dạng.')
            return
        }

        _fetchThreadColor(barcode.replace(/^#/, ''))
    }

    const _onChangeColor = (color) => {
        setSelectedColor(color)
        setShowReasonBlock(color !== data.thread.current)
    }

    const _postThreadColor = async (payload) => {
        setSubmitting(true)
        try {
            const { data: res } = await updateItemSewingThreadColor(payload)
            const { success, message: mess, error: errMsg } = res || {}
            if (!success) {
                notification.error({ message: 'Xác nhận màu chỉ không thành công', description: errMsg || mess })
                return
            }
            notification.success({ message: 'Đã ghi nhận màu chỉ may thành công' })
            _reset()
        } catch (e) {
            notification.error({ message: 'Xác nhận màu chỉ không thành công', description: e.message })
        } finally {
            setSubmitting(false)
        }
    }

    const _onConfirmUseCurrent = () => {
        _postThreadColor({
            barcode: data.item.barcode,
            thread_color_used: data.thread.current,
            used_reason: 'MAPPING_UPDATED',
        })
    }

    const _onSelectReason = (reasonText) => {
        _postThreadColor({
            barcode: data.item.barcode,
            thread_color_used: selectedColor,
            used_reason: 'SEWING_CORRECTION',
            reason_text: reasonText,
        })
    }

    const _onSkipReason = () => {
        _postThreadColor({
            barcode: data.item.barcode,
            thread_color_used: selectedColor,
            used_reason: 'SEWING_CORRECTION',
        })
    }

    const _onCancelReason = () => {
        setSelectedColor(data.thread.current !== null ? data.thread.current : _getDefaultUnresolvedColor(data.thread.allowed_colors))
        setShowReasonBlock(false)
    }

    return (
        <div className='SewingThreadColorContainer'>
            <SewingThreadColorPage
                inputValue={inputValue}
                loading={loading}
                error={error}
                data={data}
                selectedColor={selectedColor}
                showReasonBlock={showReasonBlock}
                submitting={submitting}
                inputRef={inputRef}
                onChangeInput={setInputValue}
                onSubmit={_onSubmit}
                onClear={_reset}
                onChangeColor={_onChangeColor}
                onSelectReason={_onSelectReason}
                onSkipReason={_onSkipReason}
                onCancelReason={_onCancelReason}
                onConfirmUseCurrent={_onConfirmUseCurrent}
            />
        </div>
    )
}

export default SewingThreadColorContainer
